import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-6 bg-charcoal-800 border-y border-mutedteal/20" data-id="element-31">
      <div className="max-w-3xl mx-auto text-center" data-id="element-32">
        <FadeIn data-id="element-33">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-mutedteal/10 rounded-full mb-8" data-id="element-34">
            <ShieldCheckIcon className="w-10 h-10 text-mutedteal" data-id="element-35" />
          </div>

          <h2 className="font-heading text-3xl sm:text-4xl text-offwhite mb-6" data-id="element-36">
            🛡️ Garantía de 7 días sin riesgo
          </h2>

          <p className="text-lg sm:text-xl text-offwhite/90 font-light leading-relaxed mb-6" data-id="element-37">
            Si aplicás el protocolo este fin de semana y no sentís una
            diferencia real en tu nivel de estrés, te devolvemos el 100% del
            dinero. Sin preguntas. Sin formularios. Sin drama.
          </p>

          <p className="text-amber font-heading text-xl sm:text-2xl" data-id="element-38">
            El riesgo es nuestro. El resultado es tuyo.
          </p>
        </FadeIn>
      </div>
    </section>;
}